import axios, { type AxiosResponse, isAxiosError } from 'axios';

import {
  GenericHttpError,
  type GenericHttpRequest,
  type GenericHttpResponse,
  type GenericHttpTransport,
  type HttpHeaders,
} from '@iconik-io/core/src/http/generic_http_transport';

const axiosInstance = axios.create();

const fromAxiosResponse = (
  request: GenericHttpRequest,
  response: AxiosResponse,
): GenericHttpResponse => ({
  request,
  body: response.data,
  status: response.status,
  statusText: response.statusText,
  // biome-ignore lint/plugin: axios AxiosHeaders is structurally the HttpHeaders record at this boundary.
  headers: response.headers as HttpHeaders,
});

/** Network failures surface as the original axios error, only HTTP errors are wrapped. */
export const axiosTransport: GenericHttpTransport = async (
  request,
  options = {},
) => {
  try {
    const response = await axiosInstance.request({
      method: request.method,
      url: request.url,
      headers: request.headers,
      params: request.query,
      data: request.body,
      signal: options.abortSignal,
      timeout: options.timeoutMs,
    });
    return fromAxiosResponse(request, response);
  } catch (error) {
    if (isAxiosError(error) && error.response) {
      throw new GenericHttpError(
        request,
        fromAxiosResponse(request, error.response),
      );
    }
    throw error;
  }
};
